<div>
    <div>Powered by</div>
    <div>
        <div>
            <img/>
        </div>
    </div>
</div>